<dynamic-form
  [contextMenuTrigger]="menu"
  [menuContext]="{ value: formsetting, enum: null, visible: true }"
  (menuAction)="($event)"
  [label]="label"
  [noSubmit]="deactivateSave || model.Id || currentrow"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [columns]="columns"
  [savingLabel]="'ClientApp.FrontOffice.Financial.DriverSettlement.settling' | translate"
  [saveLabel]="'ClientApp.FrontOffice.Financial.DriverSettlement.settlement' | translate"
  [isShowModal]="false"
  secondClass="main-page">
  <ng-container class="content">
    <div class="header" *ngIf="formGroup">
      <ssg-select
        class="gapfile"
        name="SettledPersonnelId"
        textFieldName="Title"
        [readonly]="this.model.Id"
        valueFieldName="Id"
        userClass="select-sm"
        [dataList]="userLookup"
        [group]="formGroup"
        [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.SettledPersonnelId' | translate"
        (valueChange)="changeUser()">
      </ssg-select>
      <date-picker
        class="gapfile"
        id="dpStartDate"
        name="UntilDate"
        [disabled]="this.model.Id"
        [group]="formGroup"
        [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.UntilDate' | translate"
        textType="date"
        [disabled]="false"></date-picker>
      <time-picker
        class="gapfile"
        name="UntilTime"
        [group]="formGroup"
        [disabled]="this.model.Id"
        [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.UntilTime' | translate"
        required="true"
        userClass="select-sm"
        [disabled]="false">
      </time-picker>
      <div (click)="receiveInformation()" *ngIf="!this.model.Id" class="okbtn">
        {{ "ClientApp.FrontOffice.Financial.DriverSettlement.ReceiveInformation" | translate }}
      </div>
    </div>

    <div class="contentbox" *ngIf="showDetail || this.model.Id">
      <div class="info">
        <div class="pricemode">
          <ssg-input
            [group]="formGroup"
            name="OldRemain"
            userClass="select-sm"
            textType="text"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.OldRemain' | translate">
          </ssg-input>
          <i class="icon-add-o"></i>
        </div>

        <div class="pricemode">
          <ssg-input
            [group]="formGroup"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal()"
            name="PayableTotal"
            userClass="select-sm"
            textType="currency"
            disabled="true"
            [withComma]="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.PayableTotal' | translate"></ssg-input>
          <i class="icon-add-o"></i>
        </div>

        <div class="pricemode">
          <ssg-input
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.Debit)"
            [group]="formGroup"
            name="Debit"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.Debit' | translate"></ssg-input>
          <i class="icon-minus"></i>
        </div>

        <div class="pricemode">
          <ssg-input
            icon="icon-open_in_new-o"
            [group]="formGroup"
            (iconClick)="openInvoicesModal(SettlementEnum.Credit)"
            name="Credit"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.Credit' | translate">
          </ssg-input>
          <i class="icon-add-o"></i>
        </div>
        <div class="pricemode">
          <ssg-input
            icon="icon-open_in_new-o"
            [group]="formGroup"
            (iconClick)="openInvoicesModal(SettlementEnum.PaymentLink)"
            name="PaymentLink"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.PaymentLink' | translate">
          </ssg-input>
          <i class="icon-minus"></i>
        </div>
        <div class="pricemode">
          <ssg-input
            icon="icon-open_in_new-o"
            [group]="formGroup"
            (iconClick)="openInvoicesModal(SettlementEnum.Deposit)"
            name="TotalDeposit"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.Deposit' | translate">
          </ssg-input>
          <i class="icon-minus"></i>
        </div>
        <div class="pricemode">
          <ssg-input
            icon="icon-open_in_new-o"
            [group]="formGroup"
            (iconClick)="openInvoicesModal(SettlementEnum.OnlinePayment)"
            name="OnlinePayment"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.OnlinePayment' | translate">
          </ssg-input>
          <i class="icon-minus"></i>
        </div>
        <div class="pricemode totlal">
          <ssg-input
            [group]="formGroup"
            name="TotalPayment"
            class="total-payment"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.TotalPayment' | translate">
          </ssg-input>
        </div>

        <div class="bikerent">
          <ssg-input
            class="bikeinfo"
            [group]="formGroup"
            name="ShippingCost"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.ShippingCost' | translate"></ssg-input>
          <ssg-input
            [group]="formGroup"
            name="CourierShippingCost"
            textType="currency"
            userClass="select-sm"
            disabled="true"
            [withComma]="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.CourierShippingCost' | translate">
          </ssg-input>
        </div>

        <div class="fractional">
          <ssg-input
            [group]="formGroup"
            name="PayableWithShippingCost"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.PayableWithShippingCost' | translate">
          </ssg-input>
          <ssg-input
            [group]="formGroup"
            name="PayableWithCourierShippingCost"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.PayableWithCourierShippingCost' | translate">
          </ssg-input>
        </div>
      </div>
      <div class="payment" *ngIf="currentrow">
        <div *ngIf="this.model.ReceiptPayments && this.model.ReceiptPayments.length > 0">
          <div class="recive" *ngFor="let item of this.model.ReceiptPayments; let i = index">
            <div class="paymentmethodbox peymenttype">
              <ssg-input
                [name]="'PaymentMethodTitle' + i"
                userClass="select-sm"
                [group]="formGroup"
                disabled="true"
                [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.PaymentMethodId' | translate">
              </ssg-input>
            </div>
            <div class="paymentmethodbox peymenttype">
              <ssg-input
                [name]="'ReceiptPaymentTypeTitle' + i"
                textFieldName="Title"
                userClass="select-sm"
                disabled="true"
                class="peymentkind"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.ReceiptPaymentTypeId' | translate">
              </ssg-input>
            </div>
            <div class="paymenprice">
              <ng-container *ngIf="formGroup?.controls['ReceiptPaymentTypeTitle' + i]?.value == 'دریافت'; else elseTemplate">
                <ssg-input
                  class="receivedmoney recivepayment"
                  userClass="select-sm"
                  [group]="formGroup"
                  [name]="'Amount' + i"
                  textType="currency"
                  [withComma]="true"
                  disabled="true"
                  [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.ReceivedMoney' | translate">
                </ssg-input>
                <ssg-input
                  *ngIf="item.PaymentMethodCode === PaymentMethodType.Pos"
                  [group]="formGroup"
                  name="TerminalNumber"
                  textType="text"
                  userClass="select-sm"
                  disabled="true"
                  [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.TerminalNumber' | translate">
                </ssg-input>
              </ng-container>
              <ng-template #elseTemplate>
                <ssg-input
                  class="receivedmoney recivepayment"
                  userClass="select-sm"
                  [group]="formGroup"
                  [name]="'Amount' + i"
                  textType="currency"
                  [withComma]="true"
                  disabled="true"
                  [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.PaymentMoney' | translate">
                </ssg-input>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="pricemode">
          <ssg-input
            [group]="formGroup"
            disabled="true"
            name="AllowedDeficit"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            hasClear="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.AllowedDeficit' | translate"
            hasClear="true"></ssg-input>
        </div>
        <div class="pricemode">
          <ssg-input
            class="bikeinfo"
            [group]="formGroup"
            name="NewRemainValue"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.Remain' | translate"></ssg-input>
        </div>
        <div class="pricemode">
          <ssg-textarea
            id="Description"
            name="Description"
            userClass="select-sm"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.Description' | translate"
            disabled="true"
            maxLength="1000"
            class="info">
          </ssg-textarea>
        </div>
      </div>
      <div class="payment" *ngIf="!currentrow">
        <div *ngIf="this.model.ReceiptPayments && this.model.ReceiptPayments.length > 0">
          <div class="recive" *ngFor="let item of this.model.ReceiptPayments">
            <div class="paymentmethodbox peymenttype">
              <ssg-select
                [readonly]="this.model.Id"
                [name]="controlName('PaymentMethodId', item.Index)"
                userClass="select-sm"
                [group]="formGroup"
                [dataList]="item.PaymentMethod"
                (valueChange)="calculate()"
                [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.PaymentMethodId' | translate"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-select>
            </div>
            <div class="paymentmethodbox peymenttype">
              <ssg-select
                [name]="controlName('ReceiptPaymentTypeId', item.Index)"
                [disabled]="model.Id || item.Id"
                textFieldName="Title"
                valueFieldName="Id"
                userClass="select-sm"
                [dataList]="item.ReceiptPaymentType"
                class="peymentkind"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.ReceiptPaymentTypeId' | translate"
                (valueChange)="checkIsPosPayment($event, item.Index); calculate()">
              </ssg-select>
            </div>
            <div class="paymenprice">
              <ng-container *ngIf="formGroup?.controls['ReceiptPaymentTypeId' + item.Index]?.value === receiveId; else elseTemplate">
                <ssg-input
                  class="receivedmoney recivepayment"
                  hasClear="true"
                  (clear)="clear(1)"
                  userClass="select-sm"
                  [group]="formGroup"
                  [name]="controlName('receivedmoney', item.Index)"
                  textType="currency"
                  [withComma]="true"
                  [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.ReceivedMoney' | translate"
                  (valueChange)="calculate()">
                </ssg-input>
                <ssg-input
                  *ngIf="item.hasTerminal"
                  [group]="formGroup"
                  name="TerminalNumber"
                  textType="text"
                  userClass="select-sm"
                  [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.TerminalNumber' | translate">
                </ssg-input>
              </ng-container>
              <ng-template #elseTemplate>
                <ssg-input
                  class="receivedmoney recivepayment"
                  hasClear="true"
                  (clear)="clear(1)"
                  userClass="select-sm"
                  [group]="formGroup"
                  [name]="controlName('receivedmoney', item.Index)"
                  textType="currency"
                  [withComma]="true"
                  [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.PaymentMoney' | translate"
                  (valueChange)="calculate()">
                </ssg-input>
              </ng-template>

              <div class="deletepeyment" *ngIf="item.State !== RowState.Modify">
                <i class="deleteicon disable icon-delete-o" (click)="removePayment(item.Index)"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="okbtn newrecive" (click)="addPayment()" *ngIf="!this.model.Id">
          {{ "ClientApp.FrontOffice.Financial.DriverSettlement.NewRecive" | translate }} +
        </div>
        <div class="pricemode">
          <ssg-input
            [group]="formGroup"
            (valueChange)="calculate()"
            [disabled]="this.model.Id"
            name="AllowedDeficit"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            hasClear="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.AllowedDeficit' | translate"
            hasClear="true"
            (clear)="clear(1)"></ssg-input>
        </div>

        <div class="pricemode">
          <ssg-input
            class="bikeinfo"
            [group]="formGroup"
            name="Remain"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.Remain' | translate"></ssg-input>
        </div>
        <div class="pricemode">
          <ssg-textarea
            id="Description"
            name="Description"
            userClass="select-sm"
            [group]="formGroup"
            type="text"
            [label]="'ClientApp.FrontOffice.Financial.DriverSettlement.Description' | translate"
            disabled="false"
            maxLength="1000"
            class="info">
          </ssg-textarea>
        </div>
      </div>
    </div>
  </ng-container>
</dynamic-form>
